import React from 'react'
import MenuItem from 'material-ui/MenuItem'
import config from '../../config'

const buildMenuItems = (resource) => {
  const { type = '' } = resource

  return [
    <MenuItem primaryText='Edit' key='edit' value={`/cms/posts/${resource.id}/edit`} />,
    <MenuItem key='View Post'>
      <a
        style={{ color: 'inherit', textDecoration: 'none' }}
        href={`${config.webUrl}${type.replace(/_/g, '-')}/${resource.slug}`}
        target='_blank' rel="noreferrer"
      >
        View Post
      </a>
    </MenuItem>
  ]
}

export default buildMenuItems
